import { forOwn } from '../../../lib/utilities';
import API from '../../API/api';
import FilterOptionsConstants from '../../_flux/constants/filter_options_contants';
import { loadVehicleConfiguratorMake } from '../vehicle_configurator/get_make';
import { loadVehicleConfiguratorData } from '../vehicle_configurator/get_vehicle_data';

function requestVehicleConfiguratorOptions(optionToFetch, filters) {
    const queryString = Object.keys(filters).map(key => key + '=' + filters[key]).join('&');
    return API.GET({
        apiPath: '/api/v2/vehicle/' + optionToFetch.toLowerCase() + '/?' + queryString
    }).done(response => {
        if (optionToFetch === 'vehicle_model') {
            loadVehicleConfiguratorData();
            loadVehicleConfiguratorMake();
        }

        forOwn(response, filterOptions => {
            // if (filterOptions.length > 0
            //     &&  filterOptions[0][FilterOptionsConstants.OPTION_VALUE] === '') {
            //     filterOptions.shift();
            // }
        });

        return response;
    });
}

export { requestVehicleConfiguratorOptions };
